/**
 * Final Sale price display
 * ------------------------
 * Mirrors the automatic "50% off Final Sale" product discount on the product
 * page. The theme's own variant script rewrites [data-product-price] with the
 * selected variant's full price; that node is hidden on Final Sale products and
 * this script recalculates the struck-through / discounted pair from it.
 *
 * Rounding matches snippets/final-sale.liquid (Liquid's divided_by floors), so
 * the server-rendered and client-rendered prices always agree.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (!(window.theme && theme.Currency && theme.Currency.formatMoney)) {
      return '$' + (cents / 100).toFixed(2).replace('.00', '');
    }

    var formatted = theme.Currency.formatMoney(cents, theme.moneyFormat).replace('.00', '');
    var remainder = cents % 100;

    // This shop's money format hides cents, which would round half of an
    // odd-dollar price up ($285 -> "$143" when checkout charges $142.50).
    // Where the discounted price lands on cents, show them.
    if (remainder !== 0 && formatted.indexOf('.') === -1) {
      var whole = theme.Currency.formatMoney(cents - remainder, theme.moneyFormat).replace('.00', '');
      formatted = whole + '.' + (remainder < 10 ? '0' + remainder : remainder);
    }

    return formatted;
  }

  function init(wrapper) {
    var configNode = document.querySelector('[data-final-sale-variants]');
    if (!configNode) return;

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (e) {
      return;
    }

    var wasNode = wrapper.querySelector('[data-final-sale-was]');
    var nowNode = wrapper.querySelector('[data-final-sale-now]');
    var badgeNode = wrapper.querySelector('[data-final-sale-badge]');
    var sourceNode = wrapper.querySelector('[data-product-price]');
    if (!wasNode || !nowNode || !sourceNode) return;

    var keep = 100 - config.percent;

    function variantById(id) {
      for (var i = 0; i < config.variants.length; i++) {
        if (String(config.variants[i].id) === String(id)) return config.variants[i];
      }
      return null;
    }

    function render(variant) {
      if (!variant || !variant.price) return;

      var markedDown = variant.compare_at_price > variant.price;
      if (markedDown && !config.includeMarkedDown) {
        // Not covered by the Final Sale display - fall back to the theme's price.
        wrapper.classList.remove('is-final-sale');
        sourceNode.removeAttribute('aria-hidden');
        return;
      }

      wrapper.classList.add('is-final-sale');
      sourceNode.setAttribute('aria-hidden', 'true');

      wasNode.textContent = formatMoney(variant.price);
      nowNode.textContent = formatMoney(Math.floor((variant.price * keep) / 100));
      if (badgeNode) badgeNode.textContent = config.percent + '% OFF';
    }

    var masterSelect = document.querySelector('select[name="id"]');
    if (masterSelect) {
      masterSelect.addEventListener('change', function () {
        render(variantById(masterSelect.value));
      });
    }

    // Backstop: the theme rewrites the source node on every variant change, even
    // when the master select is updated without firing a change event.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (masterSelect) render(variantById(masterSelect.value));
      }).observe(sourceNode, { childList: true, characterData: true, subtree: true });
    }
  }

  function boot() {
    var wrapper = document.querySelector('[data-final-sale]');
    if (wrapper) init(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
